import {IProductPriceHistory} from "../../interfaces/IProductPriceHistory";
import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {Line} from "react-chartjs-2";
import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import baseTheme from "../../shared/baseTheme";
import {getTheme} from "../../shared/themeUtils";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
);

const ContainChart = styled.div`
    height: ${getTheme("space.6")};
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
`

type PriceHistoryPropsType = {
  priceHistory: IProductPriceHistory;
}

type PriceEvolution = {
  date: Date,
  price: number,
  absMargin: number,
  available?: boolean
}

const ProductPriceHistory = (props: PriceHistoryPropsType) => {
  const {priceHistory} = props;
  const [data, setData] = useState({} as any)

  const options = {
    responsive: true,
    stepped: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: function (context: any) {
            return context.dataset.segment.label(context)
          }
        }
      }
    },
  };

  useEffect(() => {
    const tempData: PriceEvolution[] = []
    const labels: any[] = []
    priceHistory.datapoints.map(entry => {
      labels.push(new Date(entry.date).toDateString())
      tempData.push({
        date: new Date(entry.date),
        price: entry.lowestPrice,
        absMargin: entry.highestMargin,
        available: entry.available
      })
    })
    const dataObj = {
      labels: labels,
      stepped: true,
      datasets: [
        {
          data: tempData.map(entry => entry.price),
          borderColor: baseTheme.colors.link,
          backgroundColor: baseTheme.colors.link,
          segment: {
            borderDash: (ctx: any) => {
              const dataIndex = ctx.p1DataIndex;
              return tempData[dataIndex] && tempData[dataIndex-1].available ? [] : [6,6];
            },
            label: (ctx: any) => {
              const dataIndex = ctx.dataIndex;
              return tempData[dataIndex] && tempData[dataIndex].available
                ? tempData[dataIndex].price
                : `${tempData[dataIndex].price} - Unavailable`;
            }
          },
        },
        {
          data: tempData.map(entry => entry.absMargin),
          borderColor: baseTheme.colors.textOrange,
          backgroundColor: baseTheme.colors.textOrange,
          segment: {
            borderDash: (ctx: any) => {
              const dataIndex = ctx.p1DataIndex;
              return tempData[dataIndex] && tempData[dataIndex-1].available ? [] : [6,6];
            },
            label: (ctx: any) => {
              const dataIndex = ctx.dataIndex;
              return tempData[dataIndex] && tempData[dataIndex].available
                ? tempData[dataIndex].absMargin + " (Abs. margin)"
                : `${tempData[dataIndex].absMargin} - Unavailable (Abs. margin)`;
            }
          },
        }
      ],
    }

    setData(dataObj)
  }, [priceHistory])

  return (
    <ContainChart>
      {data && data.labels && <Line options={options} data={data} />}
    </ContainChart>
  )
}

export default ProductPriceHistory;